/** @format */
import angular from 'angular';
import { HeaderService } from 'sis-components/header/header.service.ts';
import { getInjectables } from 'sis-components/router/router-utils.ts';
import 'sis-components/service/studentApplication.service';
import 'sis-components/service/studyRight.service';
import { ModuleAttainmentApplicationComponent } from './module-attainment-application/module-attainment-application.component.ts';
'use strict';
(function () {
  angular.module('student.profile.applications', ['ui.router', 'ui.router.upgrade', 'sis-components.service.studentApplicationService', 'sis-components.service.studyRightService', 'student.profile.applications.cancelApplicationModal', ModuleAttainmentApplicationComponent.downgrade.moduleName]).config(["$stateProvider", $stateProvider => {
    findStudyModuleForApplication.$inject = ["moduleService", "studentApplication"];
    findStudentApplication.$inject = ["$transition$", "commonStudentApplicationService"];
    function findStudentApplication($transition$, commonStudentApplicationService) {
      return commonStudentApplicationService.findById($transition$.params().applicationId, {
        bypassCache: true
      });
    }
    function getModuleAttainmentApplicationDisplayName(transition) {
      const [$translate, localeService, studyModule] = getInjectables(transition, '$translate', 'localeService', 'studyModule');
      const applicationTypeName = $translate.instant('STUDENT_APPLICATIONS.TYPE.ModuleAttainmentApplication');
      return `${applicationTypeName}: ${localeService.getLocalizedValue(studyModule?.name)}`;
    }
    function findStudyModuleForApplication(moduleService, studentApplication) {
      return moduleService.get(studentApplication.moduleId);
    }
    $stateProvider.state('student.logged-in.profile.applications.module-attainment-application', {
      url: '/module-attainment/:applicationId',
      views: {
        '': {
          controller: ["$scope", "studentApplication", function ($scope, studentApplication) {
            $scope.application = studentApplication;
          }],
          template: '<app-module-attainment-application [application]="application"></app-module-attainment-application>'
        },
        'title@student.logged-in.profile': {
          template: ''
        },
        'secondaryNavigation@student.logged-in.profile': {
          template: ''
        },
        'codepanel@': {
          template: '<code-panel code="code"></code-panel>',
          controller: ["$scope", "studentApplication", function ($scope, studentApplication) {
            $scope.code = studentApplication.code;
          }]
        }
      },
      headerParams: {
        displayNameFunction: getModuleAttainmentApplicationDisplayName
      },
      resolve: {
        studentApplication: findStudentApplication,
        studyModule: findStudyModuleForApplication
      },
      data: {
        showHeader: true,
        showApplicationStateBadge: true
      }
    });
  }]).run(["$transitions", $transitions => {
    $transitions.onSuccess({
      to: state => !!state.data && state.data.showApplicationStateBadge
    }, transition => {
      // Some states use the 'studentApplication' resolve token for the application, other use just 'application'.
      let applicationToken;
      const tokens = transition.getResolveTokens();
      if (tokens.includes('studentApplication')) {
        applicationToken = 'studentApplication';
      } else if (tokens.includes('application')) {
        applicationToken = 'application';
      }
      if (applicationToken) {
        const [headerService, application] = getInjectables(transition, HeaderService, applicationToken);
        headerService.setApplicationStateBadge(application);
      }
    });
  }]);
})();